import { scaleLinear } from 'd3-scale'
import React from 'react'

import i18n from 'live/services/i18n'

import { Container, BarSquareContainer } from './styles'

const colorsArray = [
    // '#32766a',
    '#2d6f55',
    '#327844',
    '#3c924d',
    '#5fb257',
    '#99c555',
    '#d8de50',
    '#f6ed5c',
    '#ea983e',
    '#dd4e41'
]

const ColorSquare = [...colorsArray].splice(0, 9)
const ColorScale = scaleLinear().domain([0, 10, 20, 30, 40, 50, 60, 70, 80, 90]).range(colorsArray)

const HeaderCard = ({ data }) => {
    const percentValue = data ? 100 - (data?.totalBarriersDegraded * 100) / data?.totalBarriers : 0

    return (
        <Container color={ColorScale(100 - parseInt(percentValue))}>
            <div className="PowerBarDiv">
                <div className="Bar">
                    {ColorSquare.map((color, i) => (
                        <BarSquareContainer
                            key={'BarSquare-' + i}
                            color={parseInt(percentValue) > (9 - i) * 10 ? color : null}
                        />
                    ))}
                </div>
            </div>
            <div className="CenterDiv">
                <div className="Unity">
                    {data?.rig}
                    <div className="Id">{data?.id}</div>
                </div>
                <div className="Manager">
                    <div className="Label">{i18n('MANAGER')}</div>
                    {data?.rigManager}
                </div>
            </div>
            <div className="InfoDiv">
                <div className="Status">{data?.status}</div>
                <div className="Barriers">
                    <div className="Label">{i18n('BARRIERS')}</div>
                    <div className="Active">
                        <span className="Value">
                            <span>{Math.floor(100 - (data?.totalBarriersDegraded * 100) / data?.totalBarriers)}</span>%
                        </span>{' '}
                        {i18n('active')}
                    </div>
                    <div className="Degraded">
                        <span className="Value">{data?.totalBarriersDegraded}</span>/{data?.totalBarriers}{' '}
                        {i18n('degraded')}
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default HeaderCard
